/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { _ } from '_locales';
import styled, { css } from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';

import HOC from '_HOC';
import { cts_secure } from '_cts';
import apis from '_apis';
import { colors } from '_styles';
import { setDistrictsArray } from '_helpers';
import { NotFound, WaitScreen, Input } from '_components';
import { connect } from 'react-redux';
import Loader from './Loader';
import List from './components';
import { confirmHandler } from '../../utils';
import { DownloadAppBanner } from '../../../../components';
import getProjectString from './helpres';
import { BrandedAppNumber } from '../../../../constants/brandedAppNumber';

/**
 * import styles
 */
const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const SearchInputContainer = styled.div`
  width: calc(100% - 185px);
  float: left;
  margin-top: 3px;
  border-radius: 15px 0 0 15px;

  input {
    border-radius: 15px 0 0 15px;

    &:focus {
      outline: none !important;
      box-shadow: 0 0 2px 2px #51a7e8;
      border-radius: 15px 0 0 15px;
    }
  }

  @media screen and (max-width: 500px) {
    width: 100%;
    border-radius: 15px;
    float: initial;

    input {
      border-radius: 15px;

      &:focus {
        outline: none !important;
        box-shadow: 0 0 2px 2px #51a7e8;
        border-radius: 15px;
      }
    }
  }

  ${(parentWidth < 501) && css`
    width: 100%;
    border-radius: 15px;
    float: initial;

    input {
      border-radius: 15px;

      &:focus {
        outline: none !important;
        box-shadow: 0 0 2px 2px #51a7e8;
        border-radius: 15px;
      }
    }
  `};
`;
const ConfirmInputContainer = styled.div`
  width: 185px;
  border-radius: 0 15px 15px 0;
  margin-top: 3px;
  display: inline-block;

  input {
    border-radius: 0 15px 15px 0;

    &:focus {
      outline: none !important;
      box-shadow: 0 0 2px 2px #51a7e8;
    }
  }

  @media screen and (max-width: 500px) {
    display: none;

    label,
    input {
      display: none;
    }
  }

  ${(parentWidth < 501) && css`
    display: none;

    label,
    input {
      display: none;
    }
  `};
`;

const Container = styled.div`
 background-color: white;
 padding: 45px 35px;
 box-sizing: border-box;
`;

const InputHolder = styled.div`
   margin: 0 auto;
   max-width: 577px;
   position: relative;
`;

const Label = styled.label`
   font-size: 14px !important;
   
   font-weight: 400 !important;
   line-height: 1.36;
   margin-bottom: 6px;
   color: #0a1514;
   display: block;

   @media screen and (max-width: 500px) {
    text-align: center;
    font-weight: 500 !important;
    font-size: 20px !important;
    margin-bottom: 60px;
   }

  ${(parentWidth < 501) && css`
    text-align: center;
    font-weight: 500 !important;
    font-size: 20px !important;
    margin-bottom: 60px;
  `};
`;

const inputStyle = {
  width: '100%',
  border: 'none',
  backgroundColor: '#f3f2f2',
  fontSize: '14px',
  color: '#000',
  fontWeight: '400',
  padding: '23px',
  boxSizing: 'border-box',
  lineHeight: '15px',
};

const submitInputStyle = {
  width: '100%',
  border: 'none',
  fontSize: '14px',
  color: '#f3f2f2',
  fontWeight: '500',
  padding: '23px 9px',
  boxSizing: 'border-box',
  margin: '0',
  lineHeight: '0'
};

const Title = styled.h2`
  color: #000;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  font-family: Roboto, sans-serif;
  margin-bottom: 20px;
`;
// End style

const ZoneSetupSearch = ({
  zone, config, plugin, props,
}) => {
  /* Define the state */
  const { exampleAddress } = zone;
  const { projectId, storeDistricts } = plugin;
  const prevRoute = props.location.state;
  const { main_color = '' } = config.templateColour ? JSON.parse(config.templateColour) : {};
  const {
    isMultiDistrict, districtId, shouldSeeDistrictSelector, webappConfig, selectedLang
  } = config;
  const {
    has_calendar: hasCalendar,
    address_message = null,
    has_app_download = false,
    app_download_branded_app
  } = webappConfig;

  /* Hooks */
  const [term, setTerm] = useState('');
  const [error, setError] = useState(false);
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(false);

  const history = useHistory();

  const searchLabelContent = {
    true: _('zone.to_get_waste_and_recycling_information_for_where_you_live_enter_your_address'),
    false: _('zone.find_out_your_waste_and_recycling_pickup_schedule'),
  };

  const confirmLabelContent = {
    true: _('zone.set_my_address'),
    false: _('zone.show_my_schedule'),
  };

  /**
   * Clear the address bar and false the error
   */
  useEffect(() => {
    if (term.length === 0) {
      setAddress('');
      setError(false);
    }
  }, [term]);

  /**
   * Get all the addresses based on search term
   * @param {Text} term
   */
  const fetchAddressResult = (term) => {
    const findingAddress = async () => {
      try {
        setContentLoading(true);

        let apiUrl = '';
        const firstProjectId = Object.values(storeDistricts)[0].project_id;
        const shouldCallMultiApi = !Object.values(storeDistricts)
          .every((i) => i.project_id === firstProjectId);

        if (shouldSeeDistrictSelector) {
          apiUrl = apis.getZoneJson(projectId, districtId, term);
        } else if (shouldCallMultiApi) {
          const projectString = getProjectString(storeDistricts);
          apiUrl = apis.getZoneJsonMulti(projectString, term);
        } else {
          const multiDistrictIdsString = Object.keys(storeDistricts)
            .map((district_id) => district_id);
          apiUrl = apis.getZoneJson(projectId, multiDistrictIdsString, term);
        }

        const { data, status } = await cts_secure('get', apiUrl);

        if (
          status !== 200
          && !data
          && !data.results.length
        ) throw new Error('Error fetching result of addresses, in zone setup search section.');

        setAddress((data.results.length) ? data.results : '');
        setError(!(data.results.length));

        return undefined;
      } catch (e) {
        setAddress('');
        setError(true);
        return Promise.reject(e.message);
      } finally {
        setContentLoading(false);
      }
    };

    if (
      term.length
      && term.length >= 3
    ) findingAddress();
  };

  /**
   * Prevent race Condition
   */
  const [debouncedFetchResult] = useDebouncedCallback(
    fetchAddressResult,
    1000
  );

  /**
   * Get the character from input. Using debounce to prevent the race condition
   * @param {Text} target
   */
  const onChange = async ({ target }) => {
    setTerm(target.value);
    debouncedFetchResult(target.value);
  };

  const clickHandler = async (zones, address, district_id, project_id = '') => {
    try {
      setLoading(true);

      setDistrictsArray(storeDistricts, district_id, hasCalendar, project_id);

      await confirmHandler(history, 'search', zones, address, prevRoute);
      setLoading(false);

      return undefined;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return (
    <>
      <Container>
        <InputHolder>
          {prevRoute === '/help' ? <Title>{_('zone.ok_let_start')}</Title>
            : <Label htmlFor="search-box-input">{address_message || searchLabelContent[isMultiDistrict && !shouldSeeDistrictSelector]}</Label>}
          <SearchInputContainer>
            <Input
              value={term}
              type="text"
              id="search-box-input"
              onChange={(e) => onChange(e)}
              placeholder={`${_('zone.street_name')} ${exampleAddress ? `(e.g. ${exampleAddress})` : ''}`}
              style={inputStyle}
              ariaLabel="Enter address"
            />
          </SearchInputContainer>

          <ConfirmInputContainer>
            <label htmlFor="submit-my-schedule" style={{ display: 'none' }}>
              {_('zone.show_my_schedule')}
            </label>
            <Input
              type="submit"
              id="submit-my-schedule"
              style={{
                ...submitInputStyle,
                backgroundColor: (main_color ? `#${main_color}` : colors.RC_ACTION)
              }}
              value={confirmLabelContent[isMultiDistrict && !shouldSeeDistrictSelector]}
              ariaLabel={confirmLabelContent[isMultiDistrict && !shouldSeeDistrictSelector]}
            />
          </ConfirmInputContainer>

          {
            contentLoading ? (<Loader />) : (
              <>
                {
                  (
                    address
                    && !error
                    && address.length
                  ) ? (
                    <List
                      term={term}
                      address={address}
                      onAddressItemClick={
                        ({
                          zones, address, district_id, project_id
                        }) => clickHandler(zones, address, district_id, project_id)
                      }
                    />
                  ) : null
                }
              </>
            )
          }

          {app_download_branded_app === BrandedAppNumber.CIRCULAR_MATERIALS && (
            <>
              {selectedLang === 'en_CA' && (
                <Label style={{ marginTop: 40 }}>
                  If you&apos;re address is not listed,
                  please contact
                  {' '}
                  <a href="mailto:customerservice@circularmaterials.ca" style={{ color: '#004876', textDecoration: 'underline' }}>
                    customerservice@circularmaterials.ca
                  </a>
                  {' '}
                  to be added.
                </Label>
              )}
              {selectedLang === 'fr_CA' && (
                <Label style={{ marginTop: 40 }}>

                  Si votre adresse n&apos;est pas affichée, veuillez contacter
                  {' '}
                  <a href="mailto:serviceclientele@circularmaterials.ca" style={{ color: '#004876', textDecoration: 'underline' }}>
                    serviceclientele@circularmaterials.ca
                  </a>
                  {' '}
                  afin d&apos;être ajouté.
                </Label>
              )}
            </>
          )}

          {error ? (<NotFound />) : null}
        </InputHolder>

        {
          loading && (<WaitScreen />)
        }
      </Container>
      {prevRoute !== '/help' && has_app_download && (
        <div style={{ padding: '0 20px 20px 20px' }}>
          <DownloadAppBanner />
        </div>
      )}
    </>
  );
};

export default HOC(ZoneSetupSearch);
